import { render, staticRenderFns } from "./CascaderMulti.vue?vue&type=template&id=649bd0ba&"
import script from "./CascaderMulti.vue?vue&type=script&lang=js&"
export * from "./CascaderMulti.vue?vue&type=script&lang=js&"
import style0 from "./CascaderMulti.vue?vue&type=style&index=0&id=649bd0ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports